/**
 * @module parse
 * @memberOf module:net
 */

/**
 * Парсер строки JSON
 * @alias module:net.module:parse.json
 * @param {String} data
 * @return {*}
 */
function json(data) {
    return JSON.parse(data);
}

/**
 * Парсер строки XML
 * @alias module:net.module:parse.xml
 * @param {String} data
 * @return {Document}
 */
function xml(data) {
    let xml = null;

    if (typeof window.DOMParser != "undefined") {
        xml = (new window.DOMParser()).parseFromString(data, "text/xml");
    }
    else if (typeof window.ActiveXObject != "undefined" && new window.ActiveXObject("Microsoft.XMLDOM")) {
        xml = new window.ActiveXObject("Microsoft.XMLDOM");
        xml.async = "false";
        xml.loadXML(data);
    }
    else {
        throw new Error("No XML parser found");
    }

    return xml;
}

/**
 * Автоопределение парсера, если указанный тип известен
 * @alias module:net.module:parse.parse
 * @param {String} data
 * @param {String|Function} type Функция-парсер или название одного из парсеров из этого модуля.
 * @return {*}
 */
function parse(data, type) {

    if (type instanceof Function) {
        return type(data);
    }

    if (type == 'json') {
        return json(data);
    }

    if (type == 'xml') {
        return xml(data);
    }

    return data;
}

export {json, xml};
export default parse;